import { render, staticRenderFns } from "./MemberScoreComponent.vue?vue&type=template&id=4bbbefe4&"
import script from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
export * from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberScoreComponent.vue?vue&type=style&index=0&id=4bbbefe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports